"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMutation = void 0;
const client_1 = require("@apollo/client");
const fdr_lib_context_request_1 = require("@hotelplan/fdr.lib.context.request");
const query_utils_1 = require("./query.utils");
function useMutation(document, options) {
    (0, query_utils_1.normalizeDocumentNode)(document);
    const headers = (0, fdr_lib_context_request_1.useRequestContextHeaders)();
    return (0, client_1.useMutation)(document, (0, query_utils_1.updateHeaders)(headers, options));
}
exports.useMutation = useMutation;
//# sourceMappingURL=use-mutation.hook.js.map